(function() { window.GUID_bd29843b_7026_421a_9a37_34e8201f1005 = { getGuid: function() { return "bd29843b-7026-421a-9a37-34e8201f1005"; } }; })();
var CS;
(function (CS) {
    var Controls;
    (function (Controls) {
        class Button extends Controls.ControlBase {
            get ControlId() {
                return this.$button.attr("id");
            }
            get $Control() {
                return this.$button;
            }
            OnControlInstantiation(params) {
                const me = this;
                this.$button = $(params[0]);
            }
            OnBindEvents() {
                const me = this;
                me.extraData = me.$Control.data("html");
                this.$Control.offon('click.' + this.ControlId, function (e) {
                    if (me.$Control.hasClass('is-premium-locked')) {
                        return;
                    }
                    me.Trigger(Button.EventNames.Click, {
                        jqueryEventObject: e,
                        data: {
                            extraData: me.extraData
                        }
                    });
                    CS.Analytics.Event('Button', 'Click', me.ControlId);
                    const url = me.$Control.data('href');
                    if (url != null && url != "#") {
                        CS.Nav.Go(url);
                    }
                });
                me.$button.offon('touchstart.' + me.ControlId, function (e) {
                    me.$button.offon('touchend.' + me.ControlId, function () {
                        me.$button.removeClass('touched');
                    });
                    me.$button.offon('touchmove.' + me.ControlId, function () {
                        me.$button.off('touchend');
                        me.$button.removeClass('touched');
                    });
                    me.$button.addClass('touched');
                });
            }
            OnDispose() {
                this.$Control.off('click.' + this.ControlId);
                this.$button.off('touchstart.' + this.ControlId);
                this.$Control.remove();
            }
        }
        Controls.Button = Button;
        (function (Button) {
            class Events {
                static Clicked(param) {
                    Controls.RegisterEvent(Button, EventNames.Click, param);
                }
            }
            Button.Events = Events;
            class EventNames {
            }
            EventNames.Click = "button-click";
            Button.EventNames = EventNames;
        })(Button = Controls.Button || (Controls.Button = {}));
    })(Controls = CS.Controls || (CS.Controls = {}));
})(CS || (CS = {}));

//# sourceMappingURL=button.js.map
